<template>
  <v-card :loading="loading" flat>
    
    <div class="chart-menu mb-0">
      <div v-bind:class="'submenu_news'">
        <div class="underline"></div>
        <div class="menuitem" @click="ul(0)">
          <span class="menutext">Tweets</span>
        </div>
        <div class="menuitem" @click="ul(1)">
          <span class="menutext">Macro Calendar</span>
        </div>
        <div class="menuitem" @click="ul(2)">
          <span class="menutext">Flash News</span>
        </div>

        
      </div>
    </div>
  <div id="calendar-row"></div>
    <transition name="slide-x-transition" mode="out-in">
      <keep-alive>
        <dynamicComponent
          :is="componentMap[selectedIndex]"
          :dataNews="dataNews"
          :dataCalendar="dataCalendar"
          :dataTweets="dataTweets"
        />
      </keep-alive>
    </transition>
  </v-card>
</template>
    

<script>
import axios from "axios";
import MiniNews from "@/components/minicharts_v2/miniNews.vue";
import MiniTweets from "@/components/minicharts_v2/miniTweets.vue";
import MiniCalendar from "@/components/minicharts_v2/miniCalendar.vue";
export default {
  components: { MiniNews, MiniCalendar, MiniTweets },
  data() {
    return {
      selectedIndex: 0,
      componentMap: ["MiniTweets", "MiniCalendar", "MiniNews"],
      loading: false,
      dataNews: [],
      dataCalendar: [],
      dataTweets: [],
      items: 50
    };
  },
  mounted() {
    
    if(this.$store.getters.userSubmenus.hasOwnProperty("Section3")){
      this.selectedIndex = this.$store.getters.userSubmenus["Section3"].selected
    }
    setTimeout(() => {
      this.ul(this.selectedIndex);
    }, 500);
    this.getDataNews();
    this.getDataTweets();
    this.getDataCal();
  },
  methods: {
    getDataNews() {
      this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/request/news/", {
          limit: this.items
        })
        .then(response => {
          this.loading = false;
          this.dataNews = response.data;
        });
    },
    getDataTweets() {
      this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/request/tweets/", {
          limit: this.items
        })
        .then(response => {
          this.loading = false;
          this.dataTweets = response.data;
        });
    },
    getDataCal() {
      this.loading = true;
      axios
        .post("https://tradeinpool.com:3001/api/request/calendar/")
        .then(response => {
          this.loading = false;
          this.dataCalendar = response.data;
        });
    },
    updateSelection(newSelection) {
      this.$store.dispatch("updateSubmenuTest", {
        section: "Section3",
        value: newSelection
      });
    },
    ul(newSelection) {
      this.selectedIndex = newSelection;

      this.updateSelection(newSelection)

      var menuitem = document.querySelectorAll(".submenu_news .menuitem");
      var menutext = document.querySelectorAll(
        ".submenu_news .menuitem .menutext"
      );

      for (var i = 0; i < menutext.length; i++) {
        menutext[i].style.color = null;
      }
      menutext[this.selectedIndex].style.color = "#FFFFFF";
      var width = menutext[this.selectedIndex].offsetWidth;
      var x = menuitem[this.selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(".submenu_news .underline");
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }
  },
  sockets: {
    NEWSFEED: function(data) {
      //var sortingData = this.data
      //sortingData = _.orderBy(sortingData, ['time'],['asc']); // Use Lodash to sort array by 'name'
      if (this.dataNews.length >= this.items) {
        this.dataNews.pop();
      }
      this.dataNews.unshift(data);
    },
    TWEETS: function(data) {
      //var sortingData = this.data
      //sortingData = _.orderBy(sortingData, ['time'],['asc']); // Use Lodash to sort array by 'name'
      if (this.dataTweets.length >= this.items) {
        this.dataTweets.pop();
      }
      this.dataTweets.unshift(data);
    },
    CAL_UPDATE: function(data) {
      this.dataCalendar.forEach((cal, index) => {
        if (cal.title == data.title) {
          this.$set(this.dataCalendar, index, data);
          this.flash(
            "MACRO: " + data.title + "actual: " + data.actual,
            "info",
            {
              timeout: 4000
            }
          );
        }
      });
    },
    CAL_COLOR: function(data) {
      this.dataCalendar.forEach((cal, index) => {
        if (cal.title == data.title) {
          this.$set(this.dataCalendar, index, data);
        }
      });
    },
    MARKETS: function(data) {
      alert(data)
    }
  }
};
</script>

<style scoped>
.menuitem {
  font-weight: bold;
  font-size: 12px;
  color: #808f9c;
  display: inline-block;
  z-index: 10;
  text-align: left;
  cursor: pointer;
  margin-right: 20px;
}
</style>